import { Box, Typography } from "@mui/material";
import { CustomBreadcrumbs, PreOrderInfo } from "../components";
import i18n from "i18next";

const PreOrderDetailsPage = () => {
  return (
    <Box>
      <CustomBreadcrumbs />
      <PreOrderInfo />
      <Typography variant="h5" sx={{ mt: 2 }}>
        {i18n.t("preOrder.titles.articles")}
      </Typography>
    </Box>
  );
};

export default PreOrderDetailsPage;
